import { IonCol, IonGrid, IonImg, IonInput, IonItem, IonLabel, IonRow } from '@ionic/react';
import { fetchAddressList, getAddressValue } from '../pages/Manage/ManageUser/ManageUserUtil';
import { IAddress } from '../schemas/manage/manage.Schema';
import i18n from '../../i18n';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { USER_REGISTRATION_PLACEHOLDER, PROFILE_FIELDS, PROFILE_FIELDS_PLACEHOLDER } from './constants';
import { isMobile } from './common';
import { useDispatch } from 'react-redux';
import { dispatchPcMillerRequest } from './pcMiller.util';

const ParkLocation = (props: any) => {
  const [addressList, setAddressList] = useState<Array<IAddress>>([]);
  const [showAddressList, setShowAddressList] = useState(false);
  const [isAddressEdit, setAddressEdit] = useState(true);
  const [address, setAddress] = useState(props.value);
  const { isAssignDriver = false } = props;
  const dispatch = useDispatch();

  const handlechange = (event: any) => {
    const { target: { value } } = event;
    value && setAddress(value);
    value && isAddressEdit && callAPI(value);
  }
  const handleAddress = (list: Array<IAddress>) => {
    setAddressList(list);
    setShowAddressList(true);
  };
  const fetchAddressListPCMiler = async (value: any, callback: Function) => {
    if (value.length > 2) {
      dispatchPcMillerRequest(value, (response: any) => {
        if (response) {
          const list = response.map((item: any) => ({
            addressLine1: item.Address.StreetAddress || '',
            addressLine2: '',
            addressType: '',
            city: item.Address.City || '',
            state: item.Address.State || '',
            postalCode: item.Address.Zip || ''
          }));
          callback(list);
        }
      }, dispatch);
    }
  };

  const callAPI = useCallback(
    _.debounce((value: string) => fetchAddressList(value, handleAddress), 500),
    []
  );
  useEffect(() => {
    !address && props.handleValueChange({ target: { name: 'addressDTOs', value: address } })
  }, [JSON.stringify(address)]);
  useEffect(() => {
    if (props.value) {
      setAddressEdit(false);
    }
  }, [JSON.stringify(props.value)]);
  return (
    <>
      <IonItem className={props.cssClass} data-testid="parkLocate">
        <IonLabel position="floating" mode="ios">
          {i18n.t(PROFILE_FIELDS.PARK_LOCATION)}
        </IonLabel>
        <IonInput
          type="text"
          name={"addressDTOs"}
          placeholder={!props.handelLabel ?(isAssignDriver)?i18n.t(
            USER_REGISTRATION_PLACEHOLDER.PARK_LOCATION) : i18n.t(PROFILE_FIELDS_PLACEHOLDER.PARK_LOCATION) : undefined}
          onIonChange={handlechange}
          data-testid="address-field"
          className={isMobile ? "mobile-address-field" : ""}
          onIonFocus={() => {
            setAddressEdit(true);
            setAddress(null);
          }}
          onIonBlur={() => {
            setShowAddressList(false);
            isAddressEdit && setAddress(null);
          }}
          value={
            isAddressEdit
              ? address
              : getAddressValue(
                props.value
              )
          }
          autocomplete={"none" as any}
        >
          <IonImg
            slot="end"
            src="assets/icon/search_icon.svg"
            className="search-input-icon"
          />
        </IonInput>
      </IonItem>
      {showAddressList ? (
        <IonGrid
          class="address-suggestions"
          data-test="address-suggestions"
        >
          {addressList.map(
            (address: IAddress, index: number) => (
              <IonRow
                key={`address${index}`}
                className="suggestions_item"
                data-test="suggestions_item"
                onMouseDown={() => {
                  setAddress(address);
                  setShowAddressList(false);
                  setAddressEdit(false);
                  props.handleValueChange({ target: { name: 'addressDTOs', value: address } })
                }
                }
              >
                <IonCol class="suggestions_list">
                  {getAddressValue(address)}
                </IonCol>
              </IonRow>
            )
          )}
        </IonGrid>
      ) : null}
    </>
  )
}

export default React.memo(ParkLocation);